<div class="support-nav" [ngClass]="{ 'support-nav--expanded': isExpanded }" *transloco="let translate">
  <button class="support-nav__btn" egButton egStyle="none" (click)="toggleSidebar()">
    <div fxLayoutAlign="left center">
      <img src="/assets/icons/navigation/menu.svg" class="svg-to-white" alt="menu" />
    </div>
  </button>
  <div class="menu" *transloco="let translate">
    @if (!isExpanded) {
      <p-tieredMenu [model]="items">
        <ng-template #item let-item>
          <a
            [routerLink]="item.restricted ? null : item.route || item.routerLink"
            [class.menu__link--restricted]="item.restricted"
            [pTooltip]="
              item.restricted ? translate(TRANSLOCO_PREFIX + '.noPermission') : item.icon ? translate(TRANSLOCO_PREFIX + item.label) : null
            "
            tooltipPosition="right"
            positionLeft="25"
            class="menu__link"
          >
            @if (item.icon) {
              <img [src]="item.icon" class="menu__icon svg-to-white" alt="icon" />
            } @else {
              <span class="menu__labels">{{ translate(TRANSLOCO_PREFIX + item.label) }}</span>
            }
          </a>
        </ng-template>
      </p-tieredMenu>
    } @else {
      <p-panelMenu [model]="items">
        <ng-template #item let-item>
          @if (item.route) {
            @if (item.icon) {
              <img [src]="item.icon" class="menu__icon svg-to-white" alt="icon" />
            }
            <a
              [routerLink]="item.restricted ? null : item.route"
              [class.menu__link--restricted]="item.restricted"
              [pTooltip]="item.restricted ? translate(TRANSLOCO_PREFIX + '.noPermission') : null"
              tooltipPosition="right"
            >
              <span>{{ translate(TRANSLOCO_PREFIX + item.label) }}</span>
            </a>
          } @else {
            @if (item.routerLink) {
              <a
                [ngClass]="{ 'menu__link__panel__has-icon': item.icon }"
                [routerLink]="item.restricted ? null : item.routerLink"
                [class.menu__link--restricted]="item.restricted"
                [pTooltip]="item.restricted ? translate(TRANSLOCO_PREFIX + '.noPermission') : null"
                tooltipPosition="right"
                class="menu__link__panel"
              >
                <span>{{ translate(TRANSLOCO_PREFIX + item.label) }}</span>
              </a>
            } @else {
              @if (item.icon) {
                <img [src]="item.icon" class="menu__icon svg-to-white" alt="icon" />
              }
              <span
                class="menu__panel"
                [class.menu__panel--restricted]="item.restricted"
                [pTooltip]="item.restricted ? translate(TRANSLOCO_PREFIX + '.noPermission') : null"
                tooltipPosition="right"
              >
                <span>{{ translate(TRANSLOCO_PREFIX + item.label) }}</span>
                @if (item.items) {
                  <img
                    class="menu__dropdown-icon svg-to-white"
                    src="/assets/icons/arrows/down.svg"
                    [ngClass]="{ default: !item.expanded, rotated: item.expanded }"
                    alt="Dropdown"
                  />
                }
              </span>
            }
          }
        </ng-template>
      </p-panelMenu>
    }
  </div>
</div>
